import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { CountriesEnum } from 'src/common-panel/enums/countries-enum';
import { ClinicTypesEnum } from 'src/shop-manager/common/enums/clinic-types-enum';
import { ClinicOfficeListItem } from 'src/shop-manager/common/models/internal/clinic-office-list-item.model';
import { ClinicOfficeManageService } from 'src/shop-manager/services/clinic-office-manage.service';
import { ServerValueInterpreterService } from 'src/common-panel/services/server-value-interpreter.service';
import { ShopTypesEnum } from 'src/common-panel/enums/shop-types-enum';
import { BrandTypesEnum } from 'src/common-panel/enums/brand-types-enum';
import { CountryId } from 'src/common-panel/constants/country-configs.constants';

@Component({
    selector: 'app-publish-clinic-office-dialog',
    templateUrl: './publish-clinic-office-dialog.component.html',
    styleUrls: ['./publish-clinic-office-dialog.component.css'],
    standalone: false
})
export class PublishClinicOfficeDialogComponent
{

  currentClinicOffice: ClinicOfficeListItem | undefined
  // comment: string
  ShopTypesEnum = ShopTypesEnum
  isUs: boolean = false
  isPhysical: boolean = false
  isOffice: boolean = false

  constructor(private dialogRef: MatDialogRef<any>, private clinicOfficeManageService: ClinicOfficeManageService, private serverValueInterpreterService: ServerValueInterpreterService)
  {
    this.currentClinicOffice = this.clinicOfficeManageService.currentClinicOffice
    if (this.clinicOfficeManageService.currentClinicOffice?.countryId.toString() == "US") this.isUs = true
    if (this.clinicOfficeManageService.currentClinicOffice?.shopType == ClinicTypesEnum.physical)
    {
      this.isPhysical = true
    } else
    {
      this.isPhysical = false
    }

    if (this.clinicOfficeManageService.currentClinicOffice?.type1 == ShopTypesEnum.entOffice)
    {
      this.isOffice = true
    } else
    {
      this.isOffice = false
    }
  }

  getStateName(state: string): string
  {
    return this.serverValueInterpreterService.getStateName(state);
  }

  getFullCountryName(countryId?: CountryId): CountriesEnum | string
  {
    if (countryId) return this.serverValueInterpreterService.getFullCountryNameById(countryId)
    return ''
  }

  getFullType1(type1?: ShopTypesEnum): string
  {
    if (type1) return this.serverValueInterpreterService.getFullType1(type1)
    return ''
  }

  rejectClinicOffice()
  {
    this.clinicOfficeManageService.rejectClinicOffice()
    this.dialogRef.close()
  }

  approveClinicOffice()
  {
    this.clinicOfficeManageService.approveClinicOffice()
    this.dialogRef.close()
  }

  getBrandName(brandId: BrandTypesEnum): string
  {
    return this.serverValueInterpreterService.getBrandName(brandId)
  }
}
